// The MireDataExplorer's line-colour paint expression and its band labels, read by the MIRE legend.
export const mireExplorerStore = $state({
	lineColorExpression: [] as unknown[] | string,
	stepLabels: [] as string[]
});
